import { DoubleSide, MeshPhysicalMaterial, RepeatWrapping, TextureLoader, LinearMipmapLinearFilter, LinearFilter } from "three";

export const GlassCellShaderMaterial = async () => {
	const textureLoader = new TextureLoader();

	const normalMap = await textureLoader.loadAsync("/static/textures/clearcoat.jpg"); //refraction_1.jpg
	// const clearcoat = await textureLoader.loadAsync("/static/textures/clearcoat.jpg");

	normalMap.repeat.set(4, 4);
	normalMap.wrapS = normalMap.wrapT = RepeatWrapping;

	normalMap.minFilter = LinearMipmapLinearFilter;
	normalMap.magFilter = LinearFilter;
	normalMap.generateMipmaps = true;

	const material = new MeshPhysicalMaterial({
		color: 0xffffff,
		metalness: 0,
		roughness: 0.05,
		transmission: 1,
		ior: 1.5,
		thickness: 0, //.1,
		clearcoat: 1,

		clearcoatRoughness: 0,
		normalMap: normalMap,
		// envMapIntensity: 1.5,
		transparent: true,
		side: DoubleSide,
	});

	material.userData.cleanup = () => {
		normalMap.dispose();
	};

	return material;
};
